import React, { Component } from 'react'

import Box from '../../../../../SPRINTA/atoms/Box'
import Font from '../../../../../SPRINTA/atoms/Font'
import { Col, Row } from '../../../../../SPRINTA/atoms/Grid'
import Button from '../../../../../SPRINTA/atoms/Button'
import { Text, Select, FormGroup } from '../../../../../SPRINTA/atoms/Forms'
import { Country } from '../../../../../SPRINTA/molecules/Forms'
import Textarea from '../../../../../SPRINTA/atoms/Forms/textarea'
import Placeholder from '../../../../../SPRINTA/atoms/PlaceHolder'
import Loading from '../../../../../SPRINTA/atoms/Loading'
import { dateFormat } from '../../../../../SPRINTA/helpers/Formatter' 
import { is_date } from '../../../../../SPRINTA/helpers/Validate' 
import T from '../../../../../SPRINTA/translate/T'


import * as user from '../../../../utils/user'

class ConfigData extends Component {

  state = {
    user: {},
    additionals: {},
    address: {},
    loading: true,
    saving: false,
    msgerror: null,
    msgsuccess: null,
  }

  componentWillMount() {
    user.getInfo()
    .then(data => {
      this.setState({
        loading: false,
        user: {
          ...data.user,
          birthday: data.user.birthday !== '' ? dateFormat(T.txt('date_format'), data.user.birthday) : data.user.birthday
        },
        additionals: data.additionals,
        address: data.address,
        cpfReadOnly: data.user.cpf !== '' ? true : false
      })
    })
  }

  handleChange( object, name, value ) {
    this.setState({
      [object]: {
        ...this.state[object],
        [name]: value
      }
    })
  }

  userChange( target ) {
    this.handleChange('user', target.name, target.value)
  }

  additionalsChange( target ) {
    this.handleChange('additionals', target.name, target.value)    
  }

  addressChange( target ) {
    this.handleChange('address', target.name, target.value)        
  }

  setMsg(type, msg) {
    this.setState({
      [`msg${type}`]: msg
    })
    
    window.setTimeout(() => {
      this.setState({
        [`msg${type}`]: null
      })
    }, 3000)
  }

  handleSubmit(e) {
    e.preventDefault()

    let form = {
      ...this.state.user,
      ...this.state.additionals,
      ...this.state.address
    }
    
    if(form.birthday === '') {
      this.setMsg('error', T.txt('fill_birthday'))
      return
    }
    form.birthday = dateFormat('y-m-d', form.birthday)
    if(!is_date(form.birthday)) {
      this.setMsg('error', T.txt('fill_birthday_correct'))
      return
    }

    if(form.gender === '') {
      this.setMsg('error', T.txt('fill_gender'))
      return
    }
    if(form.country === '') {
      this.setMsg('error', T.txt('fill_country'))
      return
    }
    if(form.city === '') {
      this.setMsg('error', T.txt('fill_city'))
      return
    }
    if(form.region === '') {
      this.setMsg('error', T.txt('fill_region'))
      return
    }

    
    this.setState({
      saving: true
    })
    
    user.saveBasic(form)
    .then(data => {
      this.setState({
        saving: false
      }, () => {
        this.setMsg('success', 'Dados alterados com sucesso')
      })
      
    })
  }

  render() {
    if(this.state.loading) {

      return (
        <div>
          <Placeholder type='retangle' style={{height: '40px', width: '40%'}} />
          <Placeholder type='retangle' style={{height: '20px'}} />
          <Placeholder type='retangle' style={{height: '20px'}} />
          <Placeholder type='retangle' style={{height: '20px'}} />
        </div>
      )
    }



    return (
      <form method='post' onSubmit={e => this.handleSubmit(e)}>
        <Font heading='3' weight="100">{T.text('my_data_title')}</Font>
        <Row>
          <Col size='12 8'>
            <Font style={{ margin: '30px 0' }}>
              {T.text('my_data_text')}
            </Font>
          </Col>
        </Row>
        <Box style={{ margin: '20px 0' }}>
          <Font heading='4' weight="100" style={{marginBottom: '30px'}}>{T.text('personal_data')}</Font>
          <Row>
            <Col size='12 6'>
              <FormGroup spacer='large'>
                <Text label={T.txt('full_name')} readOnly defaultValue={this.state.user.name} />
              </FormGroup>
            </Col>
            <Col size='12 6'>
              <FormGroup spacer='large'>
                <Text label={T.txt('email')} readOnly defaultValue={this.state.user.email} />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col size='12'>
              <FormGroup spacer='large'>
                <Text label={T.txt('team')} name='team' handleChange={e => this.userChange(e.target)} value={this.state.user.team} />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col size='12 6'>
              <FormGroup spacer='large'>
                <Text label={T.txt('document')} name='document' handleChange={e => this.userChange(e.target)} value={this.state.user.document} />
              </FormGroup>
            </Col>
            <Col size='12 6'>
              <FormGroup spacer='large'>
                <Text label={T.txt('CPF')} name='cpf' handleChange={e => this.userChange(e.target)} mask='###.###.###-##' readOnly={this.state.cpfReadOnly} value={this.state.user.cpf} />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col size='12 4'>
              <FormGroup spacer='large'>
                <Text label={T.txt('phone')} name='phone' handleChange={e => this.userChange(e.target)} value={this.state.user.phone} />
              </FormGroup>
            </Col>
            <Col size='12 4'>
              <FormGroup spacer='large'>
                <Text label={`${T.txt('birthday')} *`} name='birthday' handleChange={e => this.userChange(e.target)} value={this.state.user.birthday} mask='##/##/####' />
              </FormGroup>
            </Col>
            <Col size='12 4'>
              <FormGroup spacer='large'>
                <Select label={`${T.txt('gender')} *`} name='gender' handleChange={e => this.userChange(e.target)} value={this.state.user.gender}>
                  <option> {T.txt('select')} </option>
                  <option value='m'> {T.txt('male')} </option>
                  <option value='f'> {T.txt('female')} </option>
                </Select>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col size='12'>
              <Textarea handleChange={e => this.userChange(e.target)} name='userText' value={this.state.user.userText || ''} style={{ fontSize: '15px', fontWeight: 100 }} label={T.txt('bio_placeholder')} maxLength='140' />
            </Col>
          </Row>
        </Box>

        <Box style={{ margin: '30px 0' }}>
          <Font heading='4' weight="100" style={{marginBottom: '30px'}}>{T.txt('address')}</Font>

          <Row>
            <Col size='12'>
              <FormGroup spacer='large'>
                <Country language={T.getLanguage()} label='País *' name='country' value={this.state.address.country} handleChange={e => this.addressChange(e.target)}>
                  <option> {T.txt('select')} </option>
                </Country>
              </FormGroup>
            </Col>
            
          </Row>

          <Row>
            <Col size='12 6'>
                <FormGroup spacer='large'>
                  <Text label={`${T.txt('city')} *`} name='city'  handleChange={e => this.addressChange(e.target)} value={this.state.address.city} />
                </FormGroup>
            </Col>
            <Col size='12 6'>
                <FormGroup spacer='large'>
                  <Text label={`${T.txt('region_form')} *`} name='region'  handleChange={e => this.addressChange(e.target)} value={this.state.address.region} />
                </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col size='12 6'>
                <FormGroup spacer='large'>
                  <Text label={T.txt('zip_code')} name='zip' handleChange={e => this.addressChange(e.target)} value={this.state.address.zip} />
                </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col size='12'>
                <FormGroup spacer='large'>
                  <Text label={T.txt('address_form')} name='street' handleChange={e => this.addressChange(e.target)} value={this.state.address.street} />
                </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col size='12 4'>
                <FormGroup spacer='large'>
                  <Text label={T.txt('number')} name='number' handleChange={e => this.addressChange(e.target)} value={this.state.address.number} />
                </FormGroup>
            </Col>
            <Col size='12 4'>
                <FormGroup spacer='large'>
                  <Text label={T.txt('complement')} name='complement' handleChange={e => this.addressChange(e.target)} value={this.state.address.complement} />                  
                </FormGroup>
            </Col>
            <Col size='12 4'>
                <FormGroup spacer='large'>
                  <Text label={T.txt('neighborhood')} name='neighborhood' handleChange={e => this.addressChange(e.target)} value={this.state.address.neighborhood} />                  
                </FormGroup>
            </Col>
          </Row>

        </Box>

        <Row>
          <Col size='12 6'>
            <Box style={{textAlign: 'center', paddingBottom: '60px'}}>
              <Font heading='4' weight="100">{T.text('health_data')}</Font>
              <Font style={{ margin: '15px 0' }}>
                {T.text('health_data_text')}
              </Font>
              <Col>
                <Row>
                  <FormGroup spacer='large'>
                    <Select value={this.state.additionals.bloodType} label={T.txt('bloodtype')} name='bloodType' handleChange={e => this.additionalsChange(e.target)}>
                      <option> {T.txt('select')} </option>
                      <option value='A+'> A+ </option>
                      <option value='A-'> A- </option>
                      <option value='B+'> B+ </option>
                      <option value='B-'> B- </option>
                      <option value='AB+'> AB+ </option>
                      <option value='AB-'> AB- </option>
                      <option value='O+'> O+ </option>
                      <option value='O-'> O- </option>
                    </Select>
                  </FormGroup>
                </Row>
              </Col>
            </Box>
          </Col>

          <Col size='12 6'>
            <Box style={{textAlign: 'center'}}>
              <Font heading='4' weight="100">{T.text('emergency_data')}</Font>
              <Font style={{ margin: '15px 0' }}>
                {T.text('emergency_data_text')}
              </Font>
              <FormGroup>
                <Text label={T.txt('full_name')} name='contactName' handleChange={e => this.additionalsChange(e.target)} value={this.state.additionals.contactName} />
              </FormGroup>
              <Text label={T.txt('contact')} name='contactPhoneMail' handleChange={e => this.additionalsChange(e.target)} value={this.state.additionals.contactPhoneMail} />
            </Box>
          </Col> 
        </Row>

        <Row>
          <Col size='12 8' text='center right'>
              { this.state.msgerror && (
                <p style={{ color: 'red', fontSize: '14px', margin: '30px 0' }}> {this.state.msgerror} </p>
              ) }

              { this.state.msgsuccess && (
                <p style={{ color: 'green', fontSize: '14px', margin: '30px 0' }}> {this.state.msgsuccess} </p>
              ) }
          </Col>
          <Col size='12 4' float='right' style={{ margin: '20px 0' }}>
            <Button theme='primary' disabled={this.state.saving}>
              {!this.state.saving ? `
                ${T.txt('save_changes')}
              ` : (
                <Loading color='#fff' size='30' />
              )}
            </Button>
          </Col>
        </Row>
      </form>
    )
  }

}

 export default ConfigData


// WEBPACK FOOTER //
// ./src/App/pages/Profile/Pages/ConfigData/index.js